import React, { useState, useCallback, useEffect, useRef, Fragment } from 'react'
import { withTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { changeObjectPropertyAction } from 'redux/actions'
import { initialMailingAddress } from 'redux/reducers/appReducer'

// import styles from '../MailingAddress.module.scss'
import {
  validateCityErrors,
  validatePostalCodeErrors,
  validateStreetAddressErrors,
  validateCountryErrors,
  validateSpecifyErrors,
  validateProvinceOrStateErrors,
} from 'shared/helpers/validators'
import StreetAddress from 'shared/components/Address/StreetAddress'
import City from 'shared/components/Address/City'
import PostalCode from 'shared/components/Address/PostalCode'
import CountryProvinceSelect from 'shared/components/Address/CountryProvinceSelect'
import { validateApartmentErrors } from '../../../../../shared/helpers/validators'
import Apartment from 'shared/components/Address/Apartment'

const REDUX_APP_PROPERTY = 'mailingAddress'
const DebtInformationForm = ({ t, i18n, setValidateForm, setIsError }) => {
  const dispatch = useDispatch()
  const [formErrors, setFormErrors] = useState({ ...initialMailingAddress })

  const { streetAddress, city, postalCode, country, provinceOrState, specify, apartment } = useSelector((state) => state.app.mailingAddress)

  const validateStreetAddress = (name) => {
    const newMailingErrors = { ...formErrors }
    newMailingErrors.streetAddress = validateStreetAddressErrors(name)
    setFormErrors(newMailingErrors)
  }

  const validateCity = (cityName) => {
    try {
      const newMailingErrors = { ...formErrors }
      newMailingErrors.city = validateCityErrors(cityName)
      setFormErrors(newMailingErrors)
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validatePostalCode = (number) => {
    try {
      const newMailingErrors = { ...formErrors }
      newMailingErrors.postalCode = validatePostalCodeErrors(number, country)
      setFormErrors(newMailingErrors)
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateApartment = (apt) => {
    const newMailingErrors = { ...formErrors }
    console.log('validating apt', apt)
    newMailingErrors.apartment = validateApartmentErrors(apt)
    setFormErrors(newMailingErrors)
  }

  const handleChangeObjectPropertyAction = useCallback(
    (fieldName, value) => {
      dispatch(changeObjectPropertyAction(REDUX_APP_PROPERTY, fieldName, value))
    },
    [dispatch]
  )

  const validateCountryProvince = useCallback(() => {
    return false
  }, [])

  const prevCountryRef = useRef()

  useEffect(() => {
    if (prevCountryRef.current !== undefined && prevCountryRef.current !== country) {
      dispatch(changeObjectPropertyAction(REDUX_APP_PROPERTY, 'postalCode', ''))
      setFormErrors((prevFormErrors) => ({ ...prevFormErrors, postalCode: '' }))
    }
    prevCountryRef.current = country
  }, [dispatch, country])

  const validateFields = useCallback(() => {
    const newFormErrors = { ...formErrors }

    newFormErrors.streetAddress = validateStreetAddressErrors(streetAddress)
    newFormErrors.postalCode = validatePostalCodeErrors(postalCode, country)
    newFormErrors.city = validateCityErrors(city)
    newFormErrors.apartment = apartment ? validateApartmentErrors(apartment) : ''

    newFormErrors.country = validateCountryErrors(country)

    if (country === 'Other') {
      newFormErrors.specify = validateSpecifyErrors(specify)
      newFormErrors.provinceOrState = false
    } else {
      newFormErrors.specify = false
      newFormErrors.provinceOrState = validateProvinceOrStateErrors(country, provinceOrState)
    }

    // Optionals don't have errors if they are blank
    if (!apartment) {
      delete newFormErrors.apartment
    }

    setFormErrors({ ...newFormErrors })

    const isValid = Object.values(newFormErrors).every((val) => !val)
    const isFormClean = Object.values(newFormErrors).some((val) => val === '')

    const newMailingAddress = { streetAddress, postalCode, city }

    return !isFormClean && isValid ? newMailingAddress : false
  }, [formErrors, city, postalCode, streetAddress, country, provinceOrState, specify, apartment])

  useEffect(() => {
    setValidateForm(() => validateFields)
  }, [setValidateForm, validateFields])

  return (
    <Fragment>
      <StreetAddress
        validateStreetAddress={validateStreetAddress}
        streetAddressError={formErrors.streetAddress}
        streetAddressValid={formErrors.streetAddress === '' ? '' : !formErrors.streetAddress}
        setIsError={setIsError}
        reduxAppProperty={REDUX_APP_PROPERTY}
        label={t('shared.mailing_address')}
        changeObjectPropertyAction={handleChangeObjectPropertyAction}
      />
      <Apartment
        validateApartment={validateApartment}
        apartmentError={formErrors.apartment}
        apartmentValid={formErrors.apartment === '' ? '' : !formErrors.apartment}
        setIsError={setIsError}
        reduxAppProperty={REDUX_APP_PROPERTY}
        changeObjectPropertyAction={handleChangeObjectPropertyAction}
      />
      <City
        validateCity={validateCity}
        cityError={formErrors.city}
        cityValid={formErrors.city === '' ? '' : !formErrors.city}
        setIsError={setIsError}
        reduxAppProperty={REDUX_APP_PROPERTY}
        changeObjectPropertyAction={handleChangeObjectPropertyAction}
      />
      <CountryProvinceSelect
        validate={validateCountryProvince}
        formErrors={formErrors}
        setFormErrors={setFormErrors}
        setIsError={setIsError}
        reduxAppProperty={REDUX_APP_PROPERTY}
        changeObjectPropertyAction={handleChangeObjectPropertyAction}
      />
      <PostalCode
        validatePostalCode={validatePostalCode}
        postalCodeError={formErrors.postalCode}
        postalCodeValid={formErrors.postalCode === '' ? '' : !formErrors.postalCode}
        setIsError={setIsError}
        reduxAppProperty={REDUX_APP_PROPERTY}
        changeObjectPropertyAction={handleChangeObjectPropertyAction}
        country={country}
      />
    </Fragment>
  )
}

export default withTranslation('common')(DebtInformationForm)
